// extracted by mini-css-extract-plugin
export default {"container":"WorkDetails_container__dwS-a","option":"WorkDetails_option__h9frC","imgIcon":"WorkDetails_imgIcon__P7Yfl","innerText":"WorkDetails_innerText__Q2eZn"};